/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MessengerStats } from '../models/MessengerStats';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class MessengerStatsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Retrieves a MessengerStats resource.
     * Retrieves a MessengerStats resource.
     * @returns MessengerStats MessengerStats resource
     * @throws ApiError
     */
    public apiMessengerstatsGet(): CancelablePromise<MessengerStats> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/messenger/stats',
            errors: {
                400: `Bad request`,
                403: `Forbidden`,
                404: `Not found`,
                500: `Internal server error`,
            },
        });
    }
}
